module.exports = __webpack_public_path__ + "img/P&G.1700deb0.png";